import UtilsObject from '@/utilities/UtilsObject';

import { ModelWithSmartProperties } from '@/models/ModelWithSmartProperties';
import { ModelFormatters } from '@/models/ModelFormatters';
import { ModelPropertyInfos } from '@/models/ModelPropertyInfos';

export default class mDealStacrLiability extends ModelWithSmartProperties {
  static Defaults = () => {
    return {
      BondName: null,
      Detachment: 0,
      Thickness: NaN,
      Balance: NaN,
      Coupon: 0,
      Spread: 0,
    };
  };

  static vocDbToLabel(dbName = null) {
    const ats = Object.freeze({
      Detachment: 'Detachment',
      BondName: 'Bond Name',
      Thickness: 'Thickness',
      Balance: 'Balance',
      Coupon: 'Coupon',
      Spread: 'Spread',
    });
    if (dbName) {
      return UtilsObject.getByPath(ats, dbName);
    }
    return ats;
  }

  constructor(rawModelFields = {}) {
    super(rawModelFields);

    this.ats = {
      ...mDealStacrLiability.Defaults(),
    };

    this.defineModelProperty('BondName', ModelPropertyInfos.Text);
    this.defineModelProperty('Detachment', ModelPropertyInfos.DecimalNumber);
    this.defineModelProperty('Thickness', ModelPropertyInfos.DecimalNumber);
    this.defineModelProperty('Balance', ModelPropertyInfos.DecimalNumber2Digits);
    this.defineModelProperty('Coupon', ModelPropertyInfos.DecimalNumber);
    this.defineModelProperty('Spread', ModelPropertyInfos.DecimalNumber);

    this.setRawFields({
      ...this.ats,
      ...rawModelFields
    });
  }

  validate() {
    const createErrorDescription = (msg, fieldName, fieldSysName) => {
      return {
        modelName: 'STACR',
        msg,
        field: fieldName,
        fieldSysName
      };
    };

    this._localValidationStatus = true;
    this._localValidationResults = [];

    // 'Bond Name' is an alpanumeric field. There are NO defaults EXCEPT the first line…
    // the default for the first Bond is ALWAYS 'A'.																
    // 'Detachment' is a percentage, where 0 <= Percent < 25. There are NO defaults
    // EXCEPT the first line… the default for Bond 'A' is ALWAYS 100%.																
    // 'Coupon' is an annual percentage, where 0 <= Percent < 25. The default for ALL Bonds is 0%.																
    // 'Spread' is an annual percentage, where 0 <= Percent < 25. The default for ALL Bonds is 0%.																

    // 'Detachment' is a percentage, where 0 <= Percent < 25. There are NO defaults EXCEPT the first line… the default for Bond 'A' is ALWAYS 100%.																
    if (this.BondName$ !== 'A' && !(this.Detachment$ >= 0 && this.Detachment$ < 25)) {
      this._localValidationResults.push(createErrorDescription(
        '0 <= Detachment < 25',
        mDealStacrLiability.vocDbToLabel('Detachment'),
        'Detachment'
      ));
    }

    // 'Coupon' is an annual percentage, where 0 <= Percent < 25. The default for ALL Bonds is 0%.																
    if (!(this.Coupon$ >= 0 && this.Coupon$ < 25)) {
      this._localValidationResults.push(createErrorDescription(
        '0 <= Coupon < 25',
        mDealStacrLiability.vocDbToLabel('Coupon'),
        'Coupon'
      ));
    }

    // 'Spread' is an annual percentage, where 0 <= Percent < 25. The default for ALL Bonds is 0%.																
    if (!(this.Spread$ >= 0 && this.Spread$ < 25)) {
      this._localValidationResults.push(createErrorDescription(
        '0 <= Spread < 25',
        mDealStacrLiability.vocDbToLabel('Spread'),
        'Spread'
      ));
    }

    this._localValidationStatus = this._localValidationResults.length === 0;

    return this._localValidationResults;
  }
}
